import * as React from "react";

import { EmptyPanel } from "@/components/StatePanels";

export const DiagnosisCompatibilityAgentsEmpty: React.FC = () => (
  <EmptyPanel
    description={
      <>
        条件に合うプランナーが
        <br />
        見つかりませんでした。
      </>
    }
  />
);
